const UPDATE_PLAYLIST = (state, payload) => {
  state.playlist = payload
}

const UPDATE_PLAYLIST_VIDEOS = (state, payload) => {
  state.playlists_videos = payload
}

export { UPDATE_PLAYLIST, UPDATE_PLAYLIST_VIDEOS }
